export default "/react/logoVibeMarketolog-23ac9954.png";